import {
    List,
    Datagrid,
    TextField,
    NumberField,
    DateField,
    ReferenceField,
    ShowButton,
    Show,
    SimpleShowLayout,
    Pagination,
    TopToolbar,
    FilterButton,
    ExportButton,
    SearchInput,
    ChipField,
    useRecordContext,
} from 'react-admin';

// Custom field to display user information
const UserField = () => {
    const record = useRecordContext();
    if (!record || !record.User) {
        return <span style={{ color: '#999', fontStyle: 'italic' }}>Anonymous</span>;
    }
    
    return (
        <span>
            {record.User.name} 
            <br />
            <small style={{ color: '#666' }}>({record.User.email})</small>
        </span>
    );
};

// Custom field to display location information
const LocationField = () => {
    const record = useRecordContext();
    if (!record) return null;
    
    const parts = [];
    if (record.city && record.city !== 'Local') parts.push(record.city);
    if (record.region && record.region !== 'Local') parts.push(record.region);
    if (record.country && record.country !== 'Local') parts.push(record.country);
    
    if (parts.length === 0) {
        return <span style={{ color: '#999', fontStyle: 'italic' }}>Local/Unknown</span>;
    }
    
    return <span>{parts.join(', ')}</span>;
};

// Custom field to style result count with color coding
const ResultCountField = () => {
    const record = useRecordContext();
    if (!record) return null;
    
    const count = record.result_count;
    const color = count === 0 ? '#f44336' : count < 5 ? '#ff9800' : '#4caf50';
    
    return (
        <span style={{ 
            color: color, 
            fontWeight: 'bold',
            padding: '2px 6px',
            borderRadius: '3px',
            backgroundColor: color + '20'
        }}>
            {count}
        </span>
    );
};

const searchLogFilters = [
    <SearchInput source="q" alwaysOn placeholder="Search by query, user, or location..." resettable />,
];

const ListActions = () => (
    <TopToolbar>
        <FilterButton />
        <ExportButton />
    </TopToolbar>
);

export const SearchLogList = () => (
    <List 
        pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />}
        perPage={25}
        sort={{ field: 'created_at', order: 'DESC' }}
        filters={searchLogFilters}
        filterDefaultValues={{ q: '' }}
        actions={<ListActions />}
        title="Search Logs"
    >
        <Datagrid>
            <TextField source="id" sortable />
            <TextField source="query" label="Search Query" sortable />
            <ResultCountField label="Results" sortable={false} />
            <UserField label="User" sortable={false} />
            <LocationField label="Location" sortable={false} />
            <TextField source="ip_address" label="IP Address" sortable={false} />
            <TextField source="session_id" label="Session" sortable={false} />
            <DateField source="CreatedAt" showTime={true} label="Created At" sortable />
            <ShowButton />
        </Datagrid>
    </List>
);

const SearchLogTitle = () => {
    const record = useRecordContext();
    return <span>Search Log {record ? `#${record.id}` : ''}</span>;
};

export const SearchLogShow = () => (
    <Show title={<SearchLogTitle />}>
        <SimpleShowLayout>
            <TextField source="id" label="ID" />
            <TextField source="query" label="Search Query" />
            <NumberField source="result_count" label="Results Found" />
            <UserField label="User" />
            <TextField source="ip_address" label="IP Address" />
            <LocationField label="Location" />
            <TextField source="country" label="Country" />
            <TextField source="region" label="Region/State" />
            <TextField source="city" label="City" />
            <TextField source="latitude" label="Latitude" />
            <TextField source="longitude" label="Longitude" />
            <TextField source="user_agent" label="User Agent" />
            <TextField source="session_id" label="Session ID" />
            <DateField source="CreatedAt" showTime={true}/>
            <DateField source="UpdatedAt" showTime={true}/>
        </SimpleShowLayout>
    </Show>
); 